import { render } from "./SearchBasic.vue?vue&type=template&id=1cc300ec"
import script from "./SearchBasic.vue?vue&type=script&lang=js"
export * from "./SearchBasic.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__